export const creator_6C1LH8CH = {
  hideUserReviews: true,
};